import { Shield, Zap, Lock, Mail, Globe } from "lucide-react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-4xl mx-auto px-6 py-16">
      <div className="font-mono text-xs uppercase tracking-widest text-[#00FF66]">// about us</div>
      <h1 className="font-heading font-bold text-4xl md:text-5xl mt-2 leading-tight">
        Genuine software,<br />
        <span className="text-[#00FF66]">delivered honestly.</span>
      </h1>
      <p className="text-[#A1A1AA] mt-6 leading-relaxed text-lg">
        genuine.software is an independent reseller of original software licenses — Microsoft Windows,
        Microsoft Office, antivirus subscriptions, and Autodesk product family. Every license we sell
        is genuine, retail or volume-grade, and activates against your own account.
      </p>

      <div className="grid md:grid-cols-3 gap-4 mt-12">
        {[
          { i: Zap, t: "Instant delivery", d: "Most orders complete in under 60 seconds." },
          { i: Shield, t: "100% genuine", d: "No grey-market, no patched, no cracked keys." },
          { i: Lock, t: "Your account, your control", d: "Autodesk subscriptions activate on your own email." },
          { i: Globe, t: "Worldwide access", d: "Licenses ship to any country, immediately." },
          { i: Mail, t: "Real support", d: "WhatsApp, iMessage, or email — humans, not bots." },
        ].map((b, i) => (
          <div key={i} className="surface p-5">
            <b.i className="w-5 h-5 text-[#00FF66]" />
            <div className="font-heading font-semibold text-lg mt-3">{b.t}</div>
            <div className="text-[#A1A1AA] text-sm mt-1">{b.d}</div>
          </div>
        ))}
      </div>

      <div className="surface p-8 mt-12">
        <h2 className="font-heading font-semibold text-2xl">Why us</h2>
        <p className="text-[#A1A1AA] mt-3 leading-relaxed">
          We started genuine.software because the legitimate-license market is opaque and overpriced.
          We work with authorized partners worldwide, pass on the volume discounts, and deliver
          everything digitally — no shipping, no boxes, no waste. Our Autodesk subscriptions are
          processed against your own Autodesk account so you keep full ownership and control.
        </p>
      </div>

      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/products" className="btn-primary">Browse catalog</Link>
        <Link to="/contact" className="btn-ghost">Talk to us</Link>
      </div>
    </div>
  );
}
